//ecd:13995034H20261022084009_V3.0
import { CreditCardType } from './CreditCardType';

/**
 * CreditCard
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
export interface CreditCard {

    creditCardNumber?: string;
    
    creditCardType: CreditCardType;
    
    creditCardExpDate: string;
}

/** Each field's label and limits, as the DSL declares them. */
export const CreditCardFields = {
    creditCardNumber: { label: "creditCardNumber", required: true, maxLength: 30 },
    creditCardType: { label: "creditCardType", required: true },
    creditCardExpDate: { label: "creditCardExpDate", required: true, maxLength: 5 },
} as const;

/**
 * The DSL's checks, before sending: field -> message, empty when nothing is
 * wrong. The server checks them again; this is so a form can say it first.
 * partial: an update that sends only what changed - what is required is not asked for.
 */
export function validateCreditCard(value: Partial<CreditCard> | null | undefined, partial = false): Record<string, string> {
    const errors: Record<string, string> = {};
    if (value == null) return errors;
    if (partial ? value.creditCardNumber === '' : (value.creditCardNumber == null || value.creditCardNumber === '')) errors.creditCardNumber = "creditCardNumber is required";
    else if (value.creditCardNumber != null && String(value.creditCardNumber).length > 30) errors.creditCardNumber = "creditCardNumber is at most 30 characters";
    if (!partial && value.creditCardType == null) errors.creditCardType = "creditCardType is required";
    if (partial ? value.creditCardExpDate === '' : (value.creditCardExpDate == null || value.creditCardExpDate === '')) errors.creditCardExpDate = "creditCardExpDate is required";
    else if (value.creditCardExpDate != null && String(value.creditCardExpDate).length > 5) errors.creditCardExpDate = "creditCardExpDate is at most 5 characters";
    return errors;
}
